/**
 * `HttpExceptionFilter` answers `{ success:false, message }` where `message`
 * is a string or a `ValidationPipe` string[]; `Redux/baseApi.ts`'s
 * `axiosBaseQuery` has already flattened both into `.message` by the time an
 * RTK Query error reaches a component, so this only has to survive the shapes
 * it did not flatten. Same helper `Pages/Settings/components/GuestSettingsPanel.tsx`
 * keeps under the same name, for the same reason.
 */
export function messageOf(error: unknown, fallback: string): string {
  const message = (error as { message?: unknown } | null)?.message;
  return typeof message === 'string' && message.trim() ? message : fallback;
}

/** Date-only, no time — a royalty period boundary is a day, not a moment. */
export function formatPeriodDate(value: string, locale: string): string {
  return new Intl.DateTimeFormat(locale.startsWith('ar') ? 'ar-SA' : 'en-US', {
    dateStyle: 'medium',
  }).format(new Date(value));
}
